var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmersionHeaterAndThermostat01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4.8,
    className: "st0",
    width: 10,
    height: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8.1,
    cy: 8,
    r: 3.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmersionHeaterAndThermostat01);
export default __webpack_public_path__ + "static/media/ImmersionHeaterAndThermostat-01.7e516000dfded35697783daded0601ea.svg";
export { ForwardRef as ReactComponent };